// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3d_dY","content":"styles_content__19cPw","selectAll":"styles_selectAll__3G7cH"};